import { useStore } from 'vuex';
import tinycolor from 'tinycolor2';

export const useThemedButtons = () => {
  const store = useStore();
  const primaryColor = tinycolor(store.state.globals.info.primary_color.hex).toHslString();
  const secondaryActiveBackground = tinycolor(primaryColor).setAlpha(0.3);
  const primaryTextContrast = tinycolor
    .mostReadable(primaryColor, ['#fff', secondaryActiveBackground, '#000'])
    .toHexString();

  const themedButtons = {
    '--primary-button-background': primaryColor,
    '--primary-button-text-contrast': primaryTextContrast,
    '--primary-button-border': 'none',
    '--primary-button-border-radius': '9999px',
    '--primary-button-hover': `${tinycolor(primaryColor).lighten(7)}`,
    '--primary-button-focus-outline': '0.75px solid #000FFF',
    '--secondary-button-text': primaryColor,
    '--secondary-button-text-contrast': tinycolor
      .mostReadable(secondaryActiveBackground, ['#000', primaryColor, '#fff'])
      .toHexString(),
    '--secondary-button-background': '#FFFFFF',
    '--secondary-button-border': `0.75px solid ${primaryColor}`,
    '--secondary-button-border-radius': '9999px',
    '--secondary-button-hover': tinycolor(primaryColor).setAlpha(0.2),
    '--secondary-button-hover-border': `0.75px solid ${tinycolor(primaryColor).setAlpha(0.5)}`,
    '--secondary-button-focus-outline': `0.75px solid ${primaryColor}`,
    '--secondary-button-active': secondaryActiveBackground,

    '--tertiary-button-background': tinycolor(primaryColor).setAlpha(0.1),
    '--tertiary-button-text-contrast': primaryColor,
    '--tertiary-button-border': `0.75px solid ${tinycolor(primaryColor).setAlpha(0.3)}`,
    '--tertiary-button-border-radius': '9999px',
    '--tertiary-button-hover': tinycolor(primaryColor).setAlpha(0.3),
    '--tertiary-button-hover-border': `0.75px solid ${tinycolor(primaryColor).setAlpha(0.5)}`,
    '--tertiary-button-focus-outline': `0.75px solid ${primaryColor}`,
    '--tertiary-button-active': tinycolor(primaryColor).setAlpha(0.5),
    '--tertiary-button-active-border': `0.75px solid ${primaryColor}`,

    '--disabled-button-background': '#E0E0E0',
    '--disabled-button-text-contrast': '#616161',
    '--disabled-button-tertiary-text-contrast': '#949494',
  };
  return {
    themedButtons,
  };
};
